import styled from "styled-components";
import { EmbedTheme } from "../../utils/embeds";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";

export const EmbedAuthorWrapper = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 8px;
        }
    }
`;

const UserThemableEmbedAuthorName= styled(V3BodyGrey35)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const EmbedAuthorName = styled(UserThemableEmbedAuthorName) <{ embedTheme: EmbedTheme }>`
    color: ${({ embedTheme }) => embedTheme === EmbedTheme.dark ? "white" : undefined};
`;